/** The saved-projects list, in the manner of PlanForge's: this browser's projects, newest first. */

import { useState } from "react";
import type { ProjectSummary } from "./speclens-project.ts";

interface SavedProjectsProps {
  readonly projects: readonly ProjectSummary[];
  readonly currentId: string;
  readonly onOpen: (id: string) => void;
  readonly onNew: () => void;
  readonly onDelete: (id: string) => void;
}

export function SavedProjects({ projects, currentId, onOpen, onNew, onDelete }: SavedProjectsProps) {
  const [confirming, setConfirming] = useState<string | null>(null);

  return (
    <section className="sl-card">
      <div className="sl-card__head">
        <h2 className="sl-card__title">Saved projects ({projects.length})</h2>
        <button type="button" className="btn" onClick={onNew}>
          New project
        </button>
      </div>
      {projects.length === 0 ? (
        <p className="hint">Projects you analyse are kept in this browser and listed here.</p>
      ) : (
        <ul className="sl-projects">
          {projects.map((project) => (
            <li key={project.id} className={project.id === currentId ? "sl-projects__row sl-projects__row--current" : "sl-projects__row"}>
              <button type="button" className="sl-projects__open" onClick={() => onOpen(project.id)}>
                <span className="sl-projects__name">{project.name}</span>
                <span className="hint">{new Date(project.updatedAt).toLocaleString()}</span>
              </button>
              {confirming === project.id ? (
                <span className="sl-projects__confirm">
                  Delete?
                  <button
                    type="button"
                    className="btn btn--danger"
                    onClick={() => {
                      setConfirming(null);
                      onDelete(project.id);
                    }}
                  >
                    Yes
                  </button>
                  <button type="button" className="btn btn--quiet" onClick={() => setConfirming(null)}>
                    No
                  </button>
                </span>
              ) : (
                <button type="button" className="btn btn--quiet" onClick={() => setConfirming(project.id)} aria-label={`Delete ${project.name}`}>
                  Delete
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
